import { useTranslation } from 'react-i18next';
import { z } from 'zod';

const MAX_NAME_LENGTH = 50;

export const useCreateSpaceGroupFormValidationSchema = () => {
  const { t } = useTranslation(['validation']);

  const schema = z.object({
    name: z
      .string()
      .min(2, t('validation:minLength_two', { count: 2 }))
      .max(
        MAX_NAME_LENGTH,
        t('validation:maxCharacters', { count: MAX_NAME_LENGTH }),
      )
      .regex(
        /^[a-zA-Z0-9\u0080-\uFFFF\s.,!?'_-]*$/,
        t('validation:basicCharactersOnly'),
      ),

    spaceTokens: z.array(z.string()),
  });

  return schema;
};
